import { DEVELOPMENT } from './config.development';
import { PRODUCTION } from './config.production';

const ENV_VARS = {
  staging: DEVELOPMENT,
  production: PRODUCTION,
};

export default ENV_VARS;
